import { IIndirectTaxRegistrationV2Response } from '@commenda/api/indirect-tax/registrations/types';
import { useIndirectTaxRegistrations } from '@commenda/api/indirect-tax/registrations';
import { SingleCombobox } from '@commenda/kakashi';
import { useMemo } from 'react';

interface IndirectTaxRegistrationSelectorProps {
  corporationId: number;
  value: string;
  onChange: (
    registrationTaxTypeId: string,
    registration: IIndirectTaxRegistrationV2Response | null
  ) => void;
  disabled?: boolean;
  error?: string;
}

const IndirectTaxRegistrationSelector = ({
  corporationId,
  value,
  onChange,
  disabled = false,
  error,
}: IndirectTaxRegistrationSelectorProps) => {
  // Backend caps limit at 100 (@Max(100) on IndirectTaxListRegistrationsV2QueryDTO).
  const { data: registrations, isLoading } = useIndirectTaxRegistrations({
    filters: { corporationId, limit: 100 },
  });

  const options = useMemo(
    () =>
      (registrations ?? []).map((reg) => ({
        value: reg.registrationTaxTypeId,
        label: reg.registrationName,
      })),
    [registrations]
  );

  const handleSetValue = (registrationTaxTypeId: string) => {
    const match =
      registrations?.find(
        (r) => r.registrationTaxTypeId === registrationTaxTypeId
      ) ?? null;
    onChange(registrationTaxTypeId, match);
  };

  return (
    <div className="flex flex-col gap-sm">
      <span className="txt-small-bold text-text-primary">Registration</span>
      <SingleCombobox
        options={options}
        value={value}
        setValue={handleSetValue}
        placeholder={
          isLoading ? 'Loading registrations...' : 'Select a registration'
        }
        searchPlaceholder="Search registrations"
        notFoundText="No matching registrations"
        disabled={disabled || isLoading}
        error={error}
        _className="h-11"
      />
    </div>
  );
};

export { IndirectTaxRegistrationSelector };
